export default {
    en: {
      "placeholder.label.SelectOne": "--Select One--",
    },
  
    fr: {
      "placeholder.label.SelectOne": "--Sélectionnez-en un--",
    },
  
    es: {
      "placeholder.label.SelectOne": "--Seleccione uno--",
    },
  
    pt: {
      "placeholder.label.SelectOne": "--Selecione um--",
    },
  
    zh_CN: {
      "placeholder.label.SelectOne": "--选择一个--",
    },
  
    hi: {
      "placeholder.label.SelectOne": "--एक चुनें--",
    },
  
    ka: {
      "placeholder.label.SelectOne": "--აირჩიეთ ერთი--",
    },
  
    lo: {
      "placeholder.label.SelectOne": "--ເລືອກຫນຶ່ງ--",
    },
  
    my_MM: {
      "placeholder.label.SelectOne": "--တစ်ခုရွေးပါ--",
    },
  
    my: {
      "placeholder.label.SelectOne": "--တစ်ခုရွေးပါ--",
    },
  
    vi: {
      "placeholder.label.SelectOne": "--Chọn một--",
    },
  };
  